require("./src/styles/global.css")
require("./src/styles/sectionResearch.css")
require("./src/styles/sectionPeople.css")
require("./src/styles/sectionPositions.css")
require("./src/styles/sectionPublications.css")
require("./src/styles/sectionTools.css")
require("./src/styles/sectionNews.css")
require("./src/styles/carousel.css")
require("./src/styles/alumni.css")
require("./src/styles/navbar.css")
require("./src/styles/publications.css")
require("./src/styles/contact.css")

